import React from 'react'
import { Link } from 'react-router-dom'
import SidebarAwareGrid from '#src/components/SidebarAwareGrid'
import { GridProps, Card } from '@deal/components'
import UnderlinedText from '#src/components/UnderlinedText'
import AmalfiImage from './images/amalfi.jpg'
import BahamasImage from './images/bahamas.jpg'
import CancunImage from './images/cancun.jpg'
import CroatiaImage from './images/croatia.jpg'
import IbizaImage from './images/ibiza.jpg'
import MiamiImage from './images/miami.jpg'
import MykonosImage from './images/mykonos.jpg'
import yachtSearchLocationForLocation from './yachtSearchLocationForLocation'
import styles from './styles.css'
import BackgroundImage from '#src/components/BackgroundImage'

interface YachtsByLocationProps extends GridProps {}

const YachtsByLocation: React.SFC<YachtsByLocationProps> = ({ ...rest }) => {
  const areas = `
    "one   one"
    "two   two"
    "three three"
    "four  four"
    "five  five"
    "six   six"
    "seven seven"
    "eight eight"
  `

  const areasXs = `
    "one   two"
    "three four"
    "five  six"
    "seven eight"
  `

  const areasSm = `
    "one  one  two two three three four  four"
    "five five six six seven seven eight eight"
  `

  const areasMd = `
    "one  one  one  two two two three three three four  four  four"
    "five five five six six six seven seven seven eight eight eight"
  `

  return (
    <SidebarAwareGrid
      areas={areas}
      areasXs={areasXs}
      areasSm={areasSm}
      areasMd={areasMd}
      rowGaps={true}
      {...rest}
    >
      {({ One, Two, Three, Four, Five, Six, Seven, Eight }) => {
        return (
          <>
            <One>
              <Card className={styles.titleCard}>
                Popular
                <br />
                locations
              </Card>
            </One>
            <Two>
              <Link to={yachtSearchLocationForLocation('miami-beach')}>
                <Card className={styles.locationCard}>
                  <BackgroundImage
                    contentClassName={styles.backgroundContainer}
                    height={180}
                    src={MiamiImage}
                  >
                    <UnderlinedText align="center">Miami</UnderlinedText>
                  </BackgroundImage>
                </Card>
              </Link>
            </Two>
            <Three>
              <Link to={yachtSearchLocationForLocation('croatia')}>
                <Card className={styles.locationCard}>
                  <BackgroundImage
                    contentClassName={styles.backgroundContainer}
                    height={180}
                    src={CroatiaImage}
                  >
                    <UnderlinedText align="center">Croatia</UnderlinedText>
                  </BackgroundImage>
                </Card>
              </Link>
            </Three>
            <Four>
              <Link to={yachtSearchLocationForLocation('bahamas')}>
                <Card className={styles.locationCard}>
                  <BackgroundImage
                    contentClassName={styles.backgroundContainer}
                    height={180}
                    src={BahamasImage}
                  >
                    <UnderlinedText align="center">Bahamas</UnderlinedText>
                  </BackgroundImage>
                </Card>
              </Link>
            </Four>
            <Five>
              <Link to={yachtSearchLocationForLocation('cancun')}>
                <Card className={styles.locationCard}>
                  <BackgroundImage
                    contentClassName={styles.backgroundContainer}
                    size="50vw"
                    sizeMd="200px"
                    src={CancunImage}
                  >
                    <UnderlinedText align="center">Cancun</UnderlinedText>
                  </BackgroundImage>
                </Card>
              </Link>
            </Five>
            <Six>
              <Link to={yachtSearchLocationForLocation('mykonos')}>
                <Card className={styles.locationCard}>
                  <BackgroundImage
                    contentClassName={styles.backgroundContainer}
                    height={180}
                    src={MykonosImage}
                  >
                    <UnderlinedText align="center">Mykonos</UnderlinedText>
                  </BackgroundImage>
                </Card>
              </Link>
            </Six>
            <Seven>
              <Link to={yachtSearchLocationForLocation('amalfi')}>
                <Card className={styles.locationCard}>
                  <BackgroundImage
                    contentClassName={styles.backgroundContainer}
                    height={180}
                    src={AmalfiImage}
                  >
                    <UnderlinedText align="center">Amalfi</UnderlinedText>
                  </BackgroundImage>
                </Card>
              </Link>
            </Seven>
            <Eight>
              <Link to={yachtSearchLocationForLocation('ibiza')}>
                <Card className={styles.locationCard}>
                  <BackgroundImage
                    contentClassName={styles.backgroundContainer}
                    height={180}
                    src={IbizaImage}
                  >
                    <UnderlinedText align="center">Ibiza</UnderlinedText>
                  </BackgroundImage>
                </Card>
              </Link>
            </Eight>
          </>
        )
      }}
    </SidebarAwareGrid>
  )
}

export default YachtsByLocation
